import { apiClient } from '../../utils';
import { handleError } from '../';
import { sliderType } from '../../config';

export const createTile = async ({ siteId, title, status }) => {
  try {
    const { result } = await apiClient.post('/merchant/slider/create', {
      data: { site: siteId, title, status: status || 0, type: sliderType.tile },
    });
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
